import React from 'react';
import MarketFooter, {} from 'app/components/footer/MarketFooter';
import Page from 'app/components/layout/Page';

const MarketPage = ({ ...props }) => (
  <Page footer={<MarketFooter />} {...props} />
);

export default MarketPage;
